import "./Admin-signup.css";
import React, { useState, useEffect, useCallback } from "react";
import ThemeSwitch from "../../Components/themeSwitch/themeSwitch";
import LeftSidePanel from "../../Components/leftSidePanel/leftSidePanel";
import countriesData from "../../Data/CountryCodes.json";
import zxcvbn from "zxcvbn";
import OTPInputWithTimer from "../../Components/OTPInput/otpInputField";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";
import CustomerLeftPanel from "../../Components/CustomerLeftPanel/customer-left-panel";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { CUSTOMER_TYPES } from "../../Constants/config";

const validator = require("validator");

const AdminSignup = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [focus, setFocus] = useState(false);
  const [countries, setCountries] = useState([]);
  const [strength, setStrength] = useState(null);
  const [strengthText, setStrengthText] = useState("");
  const [color, setColor] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [emailVerfied, setEmailVerfied] = useState(false);
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState(null);
  const [sessionId, setSessionId] = useState(null);

  const [mobileNumberSecond, setMobileNumberSecond] = useState("");
  const [selectedCodeSecond, setSelectedCodeSecond] = useState("");
  const [mobileFieldEnabled, setMobileFieldEnabled] = useState(true);
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [emailSecond, setEmailSecond] = useState("");
  const [emailfieldEnabled, setEmailfieldEnabled] = useState(true);
  const [showAuthQRCode, setShowAuthQRCode] = useState(false);
  const [showLoginQr, setShowLoginQr] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("terms");
  const [loading, setLoading] = useState(false);
  const [customerType, setCustomerType] = useState(null);
  const [customerTypeData, setCustomerTypeData] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const handleSelectCustomerType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setCustomerType(selectedOption.value);
  };

  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const handleCodeChangeSecond = (e) => {
    setSelectedCodeSecond(e.target.value);
  };

  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const handleScroll = () => {
    if (document.activeElement instanceof HTMLInputElement) {
      document.activeElement.blur(); // Remove focus
    }
  };
  const GetAPIcalls = async (url) => {
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getUserTypes = async () => {
    try {
      const response = await GetAPIcalls(`/v1/onboarding/user-types`);

      if (response.status == 200) {
        const AccountData = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setCustomerTypeData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setCustomerTypeData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setCustomerTypeData([]);
    } finally {
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      if (document.activeElement instanceof HTMLInputElement) {
        document.activeElement.blur(); // Remove focus
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const enableMobile = (e) => {
    e.preventDefault();
    setMobileFieldEnabled(false);
    setShowUpdateButton(true);
  };
  const enableEmail = (e) => {
    e.preventDefault();
    setEmailfieldEnabled(false);
    setShowUpdateButton(true);
  };
  const updateMobileNumber = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      try {
        const response = await postChangeMobileNumber(
          userId,
          selectedCodeSecond,
          mobileNumberSecond
        );

        if (response.status == 200) {
          showToast("Mobile Number Updated.", "success");
          setSelectedCode(selectedCodeSecond);
          setMobileNumber(mobileNumberSecond);
          setMobileFieldEnabled(true);
          setShowUpdateButton(false);
        } else {
          showToast(response.message, "error");
          return;
        }
      } catch (err) {
        showToast(err.message, "error");
        return;
      }
    }, 2000), // Debounce time
    [userId, selectedCodeSecond, mobileNumberSecond] // Dependencies
  );
  const updateEmail = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      try {
        const response = await postChangeEmail(userId, emailSecond);

        if (response.status == 200) {
          showToast("Email Updated.", "success");
          setEmail(emailSecond);
          setEmailfieldEnabled(true);
          setShowUpdateButton(false);
        } else {
          showToast(response.message, "error");
          return;
        }
      } catch (err) {
        showToast(err.message, "error");
        return;
      }
    }, 2000), // Debounce time
    [userId, emailSecond] // Dependencies
  );

  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const postSendEmailCode = async () => {
    const apiUrl = `${BASE_URL}/v1/onboarding/register/resend-email-otp`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const postChangeEmail = async (userId, email) => {
    const apiUrl = `${BASE_URL}/v1/auth/change-email`;
    const bodyData = {
      user_id: userId,
      new_email: email,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const postChangeMobileNumber = async (userId, code, mobileNumber) => {
    const apiUrl = `${BASE_URL}/v1/auth/change-mobile-number`;
    const bodyData = {
      user_id: userId,
      new_mobile_number: mobileNumber,
      country_code: code,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const postSendMobileCode = async () => {
    const apiUrl = `${BASE_URL}/v1/onboarding/register/send-phone-otp`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const postLoginAPI = async () => {
    const apiUrl = `${BASE_URL}/v1/onboarding/register`;
    const bodyData = {
      first_name: firstName,
      last_name: lastName,
      country_code: selectedCode,
      mobile_number: mobileNumber,
      email_address: email,
      password: password,
      user_type_id: customerType,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const postEmailCodeVerification = async () => {
    const apiUrl = `${BASE_URL}/v1/onboarding/register/verify-email-otp`;
    const bodyData = {
      user_id: userId,
      code: otp,
      purpose: "signup",
      session_id: sessionId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  // Handle form submission
  const handleSubmitEmail = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await postEmailCodeVerification();
        if (response.status == 200) {
          toastMessage = {
            message: "Email Verification Successful.",
            type: "success",
          };
          const responseEmailCode = await postSendMobileCode();
          if (responseEmailCode.status == 200) {
            setEmailVerfied(true);
            setFormSubmitted(true);
            toastMessage = {
              message: "OTP sent successfully!",
              type: "success",
            };
          } else {
            setEmailVerfied(false);
            toastMessage = {
              message: responseEmailCode.message,
              type: "error",
            };
            return;
          }
        } else {
          setEmailVerfied(false);
          toastMessage = { message: response.message, type: "error" };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, otp, sessionId] // Dependencies
  );
  const postMobileCodeVerification = async () => {
    const apiUrl = `${BASE_URL}/v1/onboarding/register/verify-phone-otp`;
    const bodyData = {
      user_id: userId,
      code: otp,
      purpose: "signup",
      session_id: sessionId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmitMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postMobileCodeVerification();

        if (response.status == 200) {
          toastMessage = {
            message: "Mobile Number verified.",
            type: "success",
          };
          navigate("/login");
        } else {
          toastMessage = { message: response.message, type: "error" };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, otp, sessionId] // Dependencies
  );
  const handleSubmit = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await postLoginAPI();

        if (response.status == 201) {
          console.log("Login successful");
          setUserId(response.data.id);
          setSessionId(response.data.session_id);
          setFormSubmitted(true);
          toastMessage = {
            message: response.message,
            type: "success",
          };
        } else {
          setFormSubmitted(false);
          showToast(response.message, "error");
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      email,
      password,
      firstName,
      lastName,
      selectedCode,
      mobileNumber,
      customerType,
    ] // Dependencies
  );
  const handleSubmitEmailCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const responseEmailCode = await postSendEmailCode();
        if (responseEmailCode.status == 200) {
          setFormSubmitted(true);
          toastMessage = {
            message: "OTP sent successfully!.",
            type: "success",
          };
        } else {
          setFormSubmitted(false);
          toastMessage = { message: responseEmailCode.message, type: "error" };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, sessionId] // Dependencies
  );
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    // Check password strength
    const result = zxcvbn(value);
    const score = result.score;

    // Set strength level
    setStrength(score);

    // Set condition text and color
    switch (score) {
      case 0:
        setStrengthText("Very Weak");
        setColor("text-red-500");
        break;
      case 1:
        setStrengthText("Weak");
        setColor("text-orange-500");
        break;
      case 2:
        setStrengthText("Moderate");
        setColor("text-yellow-500");
        break;
      case 3:
        setStrengthText("Strong");
        setColor("text-green-500");
        break;
      case 4:
        setStrengthText("Very Strong");
        setColor("text-blue-500");
        break;
      default:
        setStrengthText("");
        setColor("");
    }
  };
  const calculateStrength = (password) => {
    let score = 0;

    // Conditions
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    return score;
  };

  const strengthScore = calculateStrength(password);
  const handleSubmitMobileCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const responseEmailCode = await postSendMobileCode();
        if (responseEmailCode.status == 200) {
          setEmailVerfied(true);
          setFormSubmitted(true);
          toastMessage = { message: "OTP sent successfully!", type: "success" };
        } else {
          setEmailVerfied(false);
          toastMessage = {
            message: responseEmailCode.message,
            type: "error",
          };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, otp, sessionId] // Dependencies
  );
  useEffect(() => {
    getUserTypes();
  }, []);
  return (
    <div className="flex  flex-col lg:flex-row h-screen dark:bg-[#101010] bg-[#FFFFFF]">
      <CustomerLeftPanel />
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {/* Right side */}
      <div className="w-full right-div lg:w-2/5 flex flex-col">
        <ThemeSwitch />
        {formSubmitted ? (
          <div>
            {emailVerfied && !showAuthQRCode && !showLoginQr && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Please Verify your Mobile
                </h2>

                <form
                  className="w-full max-w-sm"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (otp.length < 6) {
                      showToast("Please Enter 6 digit OTP", "error");
                      return;
                    }
                    setLoading(true);
                    handleSubmitMobile(e);
                  }}
                >
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please check your mobile number for the verification code we
                    just sent you and enter the code in the box below
                  </p>
                  <div className="mb-6">
                    <label
                      htmlFor="mobileNumber"
                      className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                    >
                      Mobile Number<span className="text-red-500">*</span>
                    </label>
                    {showUpdateButton && (
                      <div className="flex  items-center">
                        <select
                          value={selectedCodeSecond}
                          onChange={handleCodeChangeSecond}
                          disabled={mobileFieldEnabled}
                          onFocus={() => setFocus(true)}
                          onBlur={() => setFocus(false)}
                          className={`border text-code disabled-text font-medium 
                             h-[2.813rem]
                           p-2 rounded-tl-lg rounded-tr-none rounded-br-none rounded-bl-lg border  ${
                             focus ? "border-black" : "border-transparent"
                           } border-r-0   border  py-2 px-3 leading-tight focus:outline-none `}
                          placeholder="AU+61"
                        >
                          {countries.map((country) => (
                            <option key={country.code} value={country.dialCode}>
                              {country.code} {country.dialCode}
                            </option>
                          ))}
                        </select>
                        <input
                          type="tel"
                          id="mobileNumber"
                          value={mobileNumberSecond}
                          disabled={mobileFieldEnabled}
                          onFocus={() => setFocus(true)}
                          onBlur={() => setFocus(false)}
                          onChange={(e) =>
                            setMobileNumberSecond(e.target.value)
                          }
                          placeholder="Mobile Number"
                          className={`border text-black disabled-text text-base font-medium h-[2.813rem]
                           p-2 rounded-tl-none rounded-tr-lg rounded-br-lg rounded-bl-none border ${
                             focus ? "border-black" : "border-transparent"
                           } rounded focus:outline-none w-full border-l-0 appearance-none`}
                        />
                      </div>
                    )}
                    {!showUpdateButton && (
                      <div className="flex  items-center">
                        <select
                          value={selectedCode}
                          onChange={handleCodeChange}
                          disabled={mobileFieldEnabled}
                          onFocus={() => setFocus(true)}
                          onBlur={() => setFocus(false)}
                          className={`border text-code disabled-text font-medium h-[2.813rem]
                           p-2 rounded-tl-lg rounded-tr-none rounded-br-none rounded-bl-lg border  ${
                             focus ? "border-black" : "border-transparent"
                           } border-r-0   border  py-2 px-3 leading-tight focus:outline-none `}
                          placeholder="AU+61"
                        >
                          {countries.map((country) => (
                            <option key={country.code} value={country.dialCode}>
                              {country.code} {country.dialCode}
                            </option>
                          ))}
                        </select>
                        <input
                          type="tel"
                          id="mobileNumber"
                          value={mobileNumber}
                          disabled={mobileFieldEnabled}
                          onFocus={() => setFocus(true)}
                          onBlur={() => setFocus(false)}
                          onChange={(e) => setMobileNumber(e.target.value)}
                          placeholder="Mobile Number"
                          className={`border text-black disabled-text text-base font-medium h-[2.813rem]
                           p-2 rounded-tl-none rounded-tr-lg rounded-br-lg rounded-bl-none border ${
                             focus ? "border-black" : "border-transparent"
                           } rounded focus:outline-none w-full border-l-0 appearance-none`}
                        />
                      </div>
                    )}
                  </div>
                  {/* uncomment if it is rqeuired in future */}
                  {/* <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          if (
                            !validator.isMobilePhone(
                              selectedCodeSecond + mobileNumberSecond,
                              "any"
                            )
                          ) {
                            console.log("country code " + selectedCodeSecond);
                            console.log(
                              "mobile number is " + mobileNumberSecond
                            );
                            console.log(
                              validator.isMobilePhone(
                                selectedCodeSecond + mobileNumberSecond,
                                "any"
                              )
                            );
                            showToast(
                              "Please enter valid mobile number",
                              "error"
                            );
                            return;
                          }
                          updateMobileNumber(e);
                        }}
                        href="#"
                        className={`text-sm font-medium  after-login hover:underline ${
                          showUpdateButton ? "Show" : "Hide"
                        }`}
                      >
                        Update
                      </a>
                    </div>
                    <a
                      onClick={enableMobile}
                      href="#"
                      className=" text-sm font-medium  after-login hover:underline"
                    >
                      change Mobile Number?
                    </a>
                  </div> */}
                  <div className="mb-4">
                    <OTPInputWithTimer
                      onOtpChange={(value) => setOtp(value)}
                      onLoadingChange={(value) => setLoading(value)}
                      initialTime={300}
                      userId={userId}
                      postCode={handleSubmitMobileCode}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Submit
                  </button>
                </form>
              </div>
            )}
            {!emailVerfied && !showAuthQRCode && !showLoginQr && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Please Verify your email
                </h2>

                <form
                  className="w-full max-w-sm"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (otp.length < 6) {
                      showToast("Please Enter 6 digit OTP", "error");
                      return;
                    }
                    setLoading(true);
                    handleSubmitEmail(e);
                  }}
                >
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please check your email for the verification code we just
                    sent you and enter the code in the box below
                  </p>
                  <div className="mb-6">
                    <label
                      htmlFor="firstName"
                      className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                    >
                      Code sent to:
                    </label>
                    {showUpdateButton && (
                      <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        value={emailSecond}
                        required={true}
                        disabled={emailfieldEnabled}
                        onChange={(e) => setEmailSecond(e.target.value)}
                        className="rounded-lg h-[2.813rem] border disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    )}
                    {!showUpdateButton && (
                      <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        value={email}
                        required={true}
                        disabled={emailfieldEnabled}
                        onChange={(e) => setEmailSecond(e.target.value)}
                        className="rounded-lg h-[2.813rem] border disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    )}
                  </div>
                  {/* Uncomment if required */}
                  {/* <div className="flex items-center pt justify-between mb-6">
                    <div className="flex items-center">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          if (!validateEmail(emailSecond)) {
                            showToast("Enter the valid email", "error");
                            return;
                          }
                          updateEmail(e);
                        }}
                        href="#"
                        className={`text-sm font-medium  after-login hover:underline ${
                          showUpdateButton ? "Show" : "Hide"
                        }`}
                      >
                        {" "}
                        Update{" "}
                      </a>
                    </div>
                    <button onClick={enableEmail}>
                      <a className=" text-sm font-medium  after-login hover:underline">
                        change Email?
                      </a>
                    </button>
                  </div> */}
                  <div className="mb-4">
                    <OTPInputWithTimer
                      onOtpChange={(value) => setOtp(value)}
                      onLoadingChange={(value) => setLoading(value)}
                      initialTime={300}
                      userId={userId}
                      postCode={handleSubmitEmailCode}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Submit
                  </button>
                </form>
              </div>
            )}
            {emailVerfied && showAuthQRCode && !showLoginQr && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Download Caprock Mobile Application.
                </h2>

                <form className="w-full max-w-sm" onSubmit={handleSubmitMobile}>
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please scan the below QR code to Download the Caprock
                    Authenticator App & Register for easy access.
                  </p>
                  <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                    {/* iOS QR Code */}
                    <div className="flex flex-col items-center">
                      <div className="flex items-center  max-w-fit  gap-1 border-2 border-black rounded-lg pr-6 pl-2 py-1 bg-white dark:bg-black">
                        <img
                          src="/apple-logo.svg"
                          alt="iOS QR Code"
                          className="w-4 h-4"
                        />
                        <div className="flex flex-col leading-tight">
                          <p className="text-[10px] text-black whitespace-nowrap">
                            Download on the
                          </p>
                          <p className="text-md font-semibold text-black whitespace-nowrap">
                            App Store
                          </p>
                        </div>
                      </div>
                      <a
                        href="https://apps.apple.com"
                        className=" mt-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/bar.png"
                          alt="App Store"
                          className="w-36 mt-1"
                        />
                      </a>
                    </div>

                    {/* QR Code Label */}
                    <p className="text-sm text-labelColour font-medium">
                      Scan the QR Code
                    </p>

                    {/* Android QR Code */}
                    <div className="flex flex-col items-center">
                      <div className="flex items-center  max-w-fit  gap-1 border-2 border-black rounded-lg pr-6 pl-2 py-1 bg-white dark:bg-black">
                        <img
                          src="/playstore-logo.svg"
                          alt="iOS QR Code"
                          className="w-4 h-4"
                        />
                        <div className="flex flex-col leading-tight">
                          <p className="text-[10px] text-black whitespace-nowrap">
                            Get It On
                          </p>
                          <p className="text-md font-semibold text-black whitespace-nowrap">
                            Google Play
                          </p>
                        </div>
                      </div>
                      <a
                        href="https://apps.apple.com"
                        className=" mt-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/bar.png"
                          alt="App Store"
                          className="w-36 mt-1"
                        />
                      </a>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Continue
                  </button>
                </form>
              </div>
            )}
            {emailVerfied && showAuthQRCode && showLoginQr && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Set up your account on the Capock Mobile Application.
                </h2>

                <form className="w-full max-w-sm" onSubmit={handleSubmitMobile}>
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please scan the QR code below using the Caprock mobile
                    application for easily log in.
                  </p>
                  <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                    {/* iOS QR Code */}
                    <div className="flex flex-col items-center">
                      <a
                        href="https://apps.apple.com"
                        className=" mt-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/bar.png"
                          alt="App Store"
                          className="w-36 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        ) : (
          <div>
            <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
              <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                Open Account
              </h2>
              <form
                className="w-full max-w-sm"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!validateEmail(email)) {
                    showToast("Enter the valid email", "error");
                    return;
                  }

                  if (
                    !validator.isMobilePhone(selectedCode + mobileNumber, "any")
                  ) {
                    console.log("country code " + selectedCode);
                    console.log("mobile number is " + mobileNumber);
                    console.log(
                      validator.isMobilePhone(
                        selectedCode + mobileNumber,
                        "any"
                      )
                    );
                    showToast("Please enter valid mobile number", "error");
                    return;
                  }
                  if (strengthScore < 4) {
                    showToast("Please Enter valid password", "error");
                    return;
                  }
                  if (password !== confirmPassword) {
                    showToast(
                      "Confirm password should be same as password",
                      "error"
                    );
                    return;
                  }
                  if (!customerType) {
                    showToast("Please select customer type", "error");
                    return;
                  }
                  setLoading(true);
                  handleSubmit(e);
                }}
              >
                <div className="mb-4">
                  <label
                    htmlFor="firstName"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    First Name<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="firstName"
                    name="firstName"
                    type="text"
                    value={firstName}
                    placeholder="Your First Name"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setfirstName(e.target.value)}
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="lastName"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Last Name<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="lastName"
                    name="lastName"
                    type="text"
                    value={lastName}
                    placeholder="Your Last Name"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setlastName(e.target.value)}
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="mobileNumber"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Mobile Number<span className="text-red-500">*</span>
                  </label>
                  <div className="flex  items-center">
                    <select
                      value={selectedCode}
                      onChange={handleCodeChange}
                      onFocus={() => setFocus(true)}
                      onBlur={() => setFocus(false)}
                      className={`border text-code font-medium h-[2.813rem]
                           p-2 rounded-tl-lg rounded-tr-none rounded-br-none rounded-bl-lg border ${
                             focus ? "border-black" : "border-[#B5B5B5]"
                           } border-r-0   border  py-2 px-3 leading-tight focus:outline-none `}
                      placeholder="AU+61"
                    >
                      {countries.map((country) => (
                        <option key={country.code} value={country.dialCode}>
                          {country.code} {country.dialCode}
                        </option>
                      ))}
                    </select>
                    <input
                      type="tel"
                      id="mobileNumber"
                      value={mobileNumber}
                      onFocus={() => setFocus(true)}
                      onBlur={() => setFocus(false)}
                      onChange={(e) => setMobileNumber(e.target.value)}
                      placeholder="Mobile Number"
                      className={`border text-black text-base font-medium h-[2.813rem]
                           p-2 rounded-tl-none rounded-tr-lg rounded-br-lg rounded-bl-none border ${
                             focus ? "border-black" : "border-[#B5B5B5]"
                           } rounded focus:outline-none w-full border-l-0 appearance-none`}
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="email"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Email<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="text"
                    value={email}
                    autoComplete="off"
                    placeholder="Your Email"
                    className={`rounded-lg h-[2.813rem] dark:text-white text-black text-base font-medium  appearance-none  w-full py-2 px-3 leading-tight focus:outline-none ${
                      email != "" && !validateEmail(email)
                        ? "border-[#FF5050] border-2"
                        : "border"
                    }`}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {email != "" && !validateEmail(email) && (
                    <label
                      htmlFor="confirmpassword"
                      className="flex mt-1 items-center font-normal text-xs text-[#FF5050] mb-1"
                    >
                      <img
                        src="/danger.svg"
                        alt="alert Icon"
                        className="h-4 w-4 mr-2"
                      />
                      Please enter a valid email address.
                    </label>
                  )}
                </div>
                {/* Password */}
                <div className="mb-4">
                  <div className="relative mt-1">
                    {/* Password Input Field */}
                    <label
                      htmlFor="password"
                      className="block color-test dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      id="password"
                      onChange={handlePasswordChange}
                      className="dark:bg-[#101010] dark:border-[#4F4F4F] rounded-lg h-[2.813rem] appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                      placeholder="Type password"
                    />
                    <button
                      type="button"
                      onClick={togglePassword}
                      className="absolute right-3 set-top"
                    >
                      {" "}
                      {showPassword ? (
                        <img src="/eye.svg" alt="Logo" className="h-auto" />
                      ) : (
                        <img
                          src="/eye-slash.svg"
                          alt="Logo"
                          className="h-auto"
                        />
                      )}
                    </button>

                    <div className="display-none flex gap-1  absolute top-0 right-0 mt-4">
                      <div
                        className={
                          strengthScore > 0 && strengthScore < 2
                            ? "bg-red-400 px-4 h-1 rounded-md"
                            : strengthScore >= 2 && strengthScore < 4
                            ? "bg-yellow-400 px-4 h-1 rounded-md"
                            : strengthScore === 4
                            ? "bg-green-400 px-4 h-1 rounded-md"
                            : "bg-gray-400 px-4 h-1 rounded-md"
                        }
                      ></div>
                      <div
                        className={
                          strengthScore >= 2 && strengthScore < 4
                            ? "bg-yellow-400 px-4 h-1 rounded-md"
                            : strengthScore === 4
                            ? "bg-green-400 px-4 h-1 rounded-md"
                            : "bg-gray-400 px-4 h-1 rounded-md"
                        }
                      ></div>
                      <div
                        className={
                          strengthScore >= 3 && strengthScore < 4
                            ? "bg-yellow-400 px-4 h-1 rounded-md"
                            : strengthScore === 4
                            ? "bg-green-400 px-4 h-1 rounded-md"
                            : "bg-gray-400 px-4 h-1 rounded-md"
                        }
                      ></div>
                      <div
                        className={
                          strengthScore === 4
                            ? "bg-green-400 px-4 h-1 rounded-md"
                            : "bg-gray-400 px-4 h-1 rounded-md"
                        }
                      ></div>
                    </div>
                  </div>
                  {/* Password Validation Conditions */}
                  <div className="mt-4 text-md font-medium">
                    <ul>
                      <li
                        className={
                          password.length >= 8 ? "text-black" : "text-[#BEBEBE]"
                        }
                      >
                        {password.length >= 8 ? (
                          <img
                            src="/tick-circle.svg"
                            alt="check"
                            className="w-5 h-5 inline mr-2 text-green-500"
                          />
                        ) : (
                          <img
                            src="/tick-circle-empty.svg"
                            alt="cross"
                            className="w-5 h-5 inline mr-2 text-red-500"
                          />
                        )}
                        At least 8 characters
                      </li>
                      <li
                        className={
                          /(?=.*[0-9])/.test(password)
                            ? "text-black"
                            : "text-[#BEBEBE]"
                        }
                      >
                        {/(?=.*[0-9])/.test(password) ? (
                          <img
                            src="/tick-circle.svg"
                            alt="check"
                            className="w-5 h-5 inline mr-2 text-green-500"
                          />
                        ) : (
                          <img
                            src="/tick-circle-empty.svg"
                            alt="cross"
                            className="w-5 h-5 inline mr-2 text-red-500"
                          />
                        )}
                        At least 1 number
                      </li>
                      <li
                        className={
                          /(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                            password
                          )
                            ? "text-black"
                            : "text-[#BEBEBE]"
                        }
                      >
                        {/(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                          password
                        ) ? (
                          <img
                            src="/tick-circle.svg"
                            alt="check"
                            className="w-5 h-5 inline mr-2 text-green-500"
                          />
                        ) : (
                          <img
                            src="/tick-circle-empty.svg"
                            alt="cross"
                            className="w-5 h-5 inline mr-2 text-red-500"
                          />
                        )}
                        At least 1 special character
                      </li>
                      <li
                        className={
                          /(?=.*[a-z])/.test(password) &&
                          /(?=.*[A-Z])/.test(password)
                            ? "text-black"
                            : "text-[#BEBEBE]"
                        }
                      >
                        {/(?=.*[a-z])/.test(password) &&
                        /(?=.*[A-Z])/.test(password) ? (
                          <img
                            src="/tick-circle.svg"
                            alt="check"
                            className="w-5 h-5 inline mr-2 text-green-500"
                          />
                        ) : (
                          <img
                            src="/tick-circle-empty.svg"
                            alt="cross"
                            className="w-5 h-5 inline mr-2 text-red-500"
                          />
                        )}
                        Both upper and lower case characters
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="mb-4 relative">
                  <label
                    htmlFor="password"
                    className="block color-test dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Confirm Password
                  </label>
                  <input
                    type={showconfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    id="password"
                    onChange={(e) => setconfirmPassword(e.target.value)}
                    className={`rounded-lg h-[2.813rem] border appearance-none w-full py-2 px-3 text-black text-base font-medium leading-tight focus:outline-none  ${
                      confirmPassword != "" && password != confirmPassword
                        ? "border-[#FF5050] border-2"
                        : "border"
                    }`}
                    placeholder="Re-Type password"
                  />

                  <button
                    type="button"
                    onClick={toggleConfirmPassword}
                    className="absolute right-3 set-top"
                  >
                    {" "}
                    {showconfirmPassword ? (
                      <img src="/eye.svg" alt="Logo" className="h-auto" />
                    ) : (
                      <img src="/eye-slash.svg" alt="Logo" className="h-auto" />
                    )}
                  </button>
                  {confirmPassword != "" && password != confirmPassword && (
                    <label
                      htmlFor="confirmpassword"
                      className="flex mt-1 items-center font-normal text-xs text-[#FF5050] mb-1"
                    >
                      <img
                        src="/danger.svg"
                        alt="alert Icon"
                        className="h-4 w-4 mr-2"
                      />
                      Please make sure your passwords match.
                    </label>
                  )}
                </div>
                <div className="mb-4">
                  <Dropdown
                    label={
                      <>
                        Customer Type
                        <span className="text-red-500">*</span>
                      </>
                    }
                    options={customerTypeData}
                    onSelect={handleSelectCustomerType}
                  />
                </div>
                <button
                  type="submit"
                  className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                >
                  Get started
                </button>
              </form>
              <div className="mt-6 max-w-sm w-full text-center">
                <img src="/line.svg" alt="Logo" className="h-auto" />
                <p className="color-test dark:text-[#CCCCCC] text-base pt-2">
                  Already have an Account?{" "}
                  <a
                    href="#"
                    onClick={() => navigate("/login")}
                    className="font-medium text-decoration text-black hover:underline"
                  >
                    Login Here
                  </a>{" "}
                </p>
              </div>
            </div>
            <div className="mt-10 md:p-0 p-10 w-full text-center">
              <p className="color-test dark:text-[#CCCCCC] text-base pt-2">
                &copy; Caprock Limited (AFSL 330742) |{" "}
                <a
                  href="#"
                  onClick={() => {
                    setActiveTab("terms");
                    setIsOpen(true);
                  }}
                  className="font-medium text-decoration text-black hover:underline"
                >
                  Terms Of Service
                </a>{" "}
                <span className="font-medium text-black">and</span>{" "}
                <a
                  href="#"
                  onClick={() => {
                    setIsOpen(true);
                    setActiveTab("privacy");
                  }}
                  className="font-medium text-decoration text-black hover:underline"
                >
                  Privacy Policy
                </a>{" "}
              </p>
              {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4">
                  <div className="w-full max-w-3xl rounded-lg shadow-lg relative">
                    <div className="p-6 space-y-0">
                      <div className="flex justify-between items-center">
                        <div className="flex space-x-0">
                          <button
                            className={`px-4 py-2 shadow-md font-medium text-sm rounded-tl-sm rounded-tr-sm rounded-br-none rounded-bl-none
                       ${
                         activeTab === "terms"
                           ? "bg-black text-white"
                           : "bg-white text-black"
                       }`}
                            onClick={() => setActiveTab("terms")}
                          >
                            Terms of Use
                          </button>
                          <button
                            className={`px-4 py-2 shadow-md font-medium text-sm rounded-tl-sm rounded-tr-sm rounded-br-none rounded-bl-none ${
                              activeTab === "privacy"
                                ? "bg-black text-white"
                                : "bg-white text-black"
                            }`}
                            onClick={() => setActiveTab("privacy")}
                          >
                            Privacy Policy
                          </button>
                        </div>
                      </div>
                      <div className="text-sm rounded-sm shadow-md bg-white text-left text-black ">
                        {activeTab === "terms" && (
                          <div className="p-6 relative ">
                            <button
                              onClick={() => setIsOpen(false)}
                              className="absolute top-2 right-2"
                            >
                              <img
                                src="/add.svg"
                                alt="Close"
                                className="w-8 h-8"
                              />
                            </button>
                            <h2 className="text-lg  font-semibold">
                              Terms of Use
                            </h2>
                            <div className="overflow-auto pr-4 max-h-[60vh]">
                              <p className="font-semibold">Disclaimer</p>
                              <p className="">
                                Your access to this website is subject to the
                                terms and conditions set out in this disclaimer,
                                Caprock’s Privacy Policy and any other notices,
                                disclaimers, statements and other terms and
                                conditions contained on this web-site (referred
                                to collectively as “the Terms and Conditions”).
                                By accessing this website and other websites
                                through links provided by us, you agree to be
                                subject to the Terms and Conditions.
                              </p>
                              <p className="font-semibold mt-1 ">Website</p>
                              <p className="">
                                The website, www.caprock.com.au, (domain name)
                                including all of its pages, information and
                                content (Website) is owned and operated by
                                Caprock Limited (ACN 098 630 972, AFS Licence
                                No. 330742) (Caprock) and related or associated
                                companies (Caprock). The sole purpose of the
                                Website is to provide general information on
                                Caprock’s business of wholesale investment
                                management.{" "}
                              </p>
                              <p className="font-semibold mt-1 ">
                                Accuracy and Reliability of this Website
                              </p>
                              <p className="">
                                The information is believed to be accurate at
                                the time of compilation and is provided by
                                Caprock in good faith. However, the use of this
                                website is at your sole risk. Neither Caprock
                                nor any other company in the Caprock, nor the
                                directors and officers of Caprock, nor the
                                trustees or responsible entitles of any trust or
                                fund, make any representation or warranty as to
                                the quality, accuracy, reliability, timeliness
                                or completeness of material in the site or
                                material in websites linked to this website.
                                Except in so far as liability under any statue
                                cannot be excluded, no member of Caprock nor
                                Caprock itself or its directors, employees and
                                consultants (Relevant Person) accept any
                                liability (whether arising in contract, tort,
                                negligence or otherwise) for any error or
                                omission in the material or for any loss or
                                damage (whether direct, indirect, consequential
                                or otherwise) suffered or liability encountered
                                by the recipient of the information or any other
                                person (Loss). You release, discharge and
                                indemnify each Relevant Person from and against
                                Loss suffered or incurred by you or any Relevant
                                Person as a result of use of this website.
                              </p>
                              <p className="font-semibold mt-1 ">
                                Amendment of Terms and Conditions
                              </p>
                              <p className="">
                                Your use of the Website also constitutes your
                                acceptance of Caprock’s Privacy Policy. You
                                should view the Privacy Policy to understand how
                                your personal information will be treated when
                                you use the Website. Caprock may, in its
                                absolute discretion, modify or amend these Terms
                                and Conditions from time to time and those
                                modifications or amendments will be binding on
                                you once displayed on the Website. Caprock has
                                no obligation to notify you of such
                                modifications or amendments so it is recommended
                                that you periodically view the Terms and
                                Conditions prior to accessing the Website.
                              </p>
                              <p className="font-semibold mt-1 ">
                                General Information Only
                              </p>
                              <p className="">
                                The information contained in this website should
                                be used as general information only. It does not
                                take into account the particular circumstances,
                                investment objectives and needs for investment
                                of any investor, or purport to be comprehensive
                                or constitute investment advice and should not
                                be relied upon as such. You should consult a
                                financial adviser to help you form your own
                                opinion of the information, and on whether the
                                information is suitable for your individual
                                needs and aims as an investor. You should
                                consult appropriate professional advisors on any
                                legal, stamp duty, taxation and accounting
                                implications of making an investment in any
                                Caprock Fund. When considering whether to use a
                                financial service offered by Caprock in this
                                website you should view the relevant Disclosure
                                Document for important information in relation
                                to those financial services. By accessing each
                                page of this website, you acknowledge receipt of
                                the relevant Disclosure Document. Further, the
                                content on the Website is not an offer or
                                solicitation to enter into any agreement of any
                                kind or intended to have that effect. Past
                                Performance Disclaimer Past performance figures
                                contained on the Website are not necessarily
                                indicative of future returns and should be used
                                as a general guide only. Returns on investments
                                necessarily are volatile and subject to change
                                and likely to vary from year to year. These
                                returns are likely to vary from year to year.
                                Returns have been calculated using exit prices
                                after taking into account all ongoing fees, and
                                assuming reinvestment of distributions. No
                                allowance has been made for entry fees, exit
                                fees or where applicable taxation. Future
                                returns may bear no relationship to the
                                historical information displayed. The returns
                                shown represent past returns only and are not
                                indicative of future returns of a Fund. Returns
                                in a Fund can be particularly volatile in the
                                short term and in some periods may be negative.
                                No Relevant Person makes any guarantee or
                                representation in regards to the performance of
                                any of the funds, nor the specific rate of
                                return to investors or the return of capital.
                                Privacy Policy We may as a result of your access
                                to this website hold and process personal
                                information obtained about you. However, Caprock
                                is committed to maintaining the privacy of any
                                personal data it holds about you, and Rolex
                                Submariner Replica Watches does so in accordance
                                with the National Privacy Principles contained
                                in the Privacy Act 1998. Please read our Privacy
                                Policy to understand how your personal
                                information will be treated when you use this
                                website. Links or Reference to other Websites
                                The Website may contain links or references to
                                other third-party websites. These links and
                                references are provided solely as a source of
                                information. The inclusion of the links and
                                references does not imply that Caprock endorses
                                these linked third-party websites. Caprock has
                                no control over the content on these linked
                                third- party websites and makes no
                                representations regarding the accuracy, replica
                                watches reliability, completeness or currency of
                                the content. You are advised to make your own
                                enquiries in relation to these third-party
                                websites. Caprock does not accept any
                                responsibility or liability for any loss or
                                liability whatsoever arising out of your use or
                                reliance on the content of these linked
                                third-party websites. Third-Party Information
                                and Materials This website may provide
                                information, articles and material that are
                                written and prepared by people who are not
                                employees or representatives of Caprock. Such
                                material is provided for your interest and
                                convenience only. The material will be clearly
                                identified as the product of an independent
                                third party. Caprock is not responsible for the
                                contents or accuracy of this material, and the
                                opinions expressed in the material should not be
                                taken as recommendations or opinions of Caprock.
                                Disclosure Documents The offer to invest in a
                                Caprock fund will be made in a copy of the
                                current disclosure document for the relevant
                                fund. Anyone wishing to invest in a fund will
                                need to complete an application form in the
                                current disclosure documents for the relevant
                                fund. Disclosure documents are issued by
                                Caprock. The disclosure document for the
                                relevant fund should be considered before
                                deciding whether to acquire or hold units in the
                                funds. Prices All figures and amounts displayed
                                on this website are in Australian dollars. All
                                asset values are historical figures based on our
                                most recent valuations. As pricing frequencies
                                and valuation methodologies differ for the
                                various types of assets, the asset values shown
                                may not be current and, therefore, you should
                                not rely on them as the basis for trading
                                investments in your account. Australian
                                investors only The information is provided for
                                Australian residents or citizens who are
                                currently located in Australia. The information
                                is not an invitation to enter into any legal
                                agreement of any kind. No statement or
                                information in this website constitutes a
                                recommendation, offer or invitation to invest in
                                any investments, securities or products of
                                Caprock or any other company in the Caprock. US
                                persons and the rest of the world excluding
                                Australia Access to this website may be
                                restricted by law in certain jurisdictions. This
                                website should not be accessed in the United
                                States of America (US) or its territories nor
                                possessions, nor be accessed by US persons. This
                                website does not constitute an extension of an
                                offer in the United States of America or to US
                                persons. Intellectual Property Rights Copyright
                                and any other intellectual property rights in
                                the content of the Website is either owned or
                                licensed by Caprock. Except to the extent
                                permitted by law, you may not in any form or by
                                any means, reproduce, adapt, upload, frame,
                                link, distribute, store, print, display,
                                broadcast, publish or create derivative works
                                from any of the content on the Website or
                                commercialise any part of the Website, without
                                Caprock's written permission. The trademarks
                                used on the Website are owned by Caprock. You
                                must not reproduce or use these trademarks
                                without Caprock's written permission. Website
                                Integrity While care has been taken to prevent
                                the introduction of viruses on to the Website,
                                Caprock does not guarantee that the Website is
                                free from viruses. You acknowledge that Caprock
                                will not be responsible for trusty time any
                                corruption or failed transmission of any
                                information caused by to your computer system or
                                the system or any act or omission of your
                                Internet Service Provider. You agree not to use
                                any device, software or process to interfere or
                                attempt to interfere with the functionality of
                                the Website. You acknowledge that your access to
                                the Website may: * at times be interrupted; and
                                * be interfered with by factors or circumstances
                                outside of Caprock's control. Emails from
                                Caprock Linked to this Disclaimer Private and
                                confidential emails and any files transmitted
                                with them are intended solely for the use of the
                                addressee(s) and may contain information which
                                is confidential or privileged. If you receive an
                                email from Caprock and you are not the addressee
                                (or responsible for delivery of the email to the
                                addressee), please disregard the contents of the
                                email, delete the email and notify the author
                                immediately. Governing Law and Forum These terms
                                and conditions of use are governed by and
                                construed in accordance with the laws of the
                                State of New South Wales, Australia. You
                                irrevocably and unconditionally submit to the
                                non-exclusive jurisdiction of the courts of New
                                South Wales (and any courts which may hear
                                appeals from those courts) and waive any right
                                to object to proceedings being brought in those
                                courts in respect of any proceedings in
                                connection with these Terms and Conditions or
                                this website.
                              </p>
                            </div>
                          </div>
                        )}
                        {activeTab === "privacy" && (
                          <div className="p-6 relative ">
                            <button
                              onClick={() => setIsOpen(false)}
                              className="absolute top-2 right-2"
                            >
                              <img
                                src="/add.svg"
                                alt="Close"
                                className="w-8 h-8"
                              />
                            </button>
                            <h2 className="text-lg  font-semibold">
                              Privacy Policy
                            </h2>
                            <div className="overflow-auto pr-4 max-h-[60vh]">
                              <div className="">
                                <p className="mb-4">
                                  <strong>Caprock Limited</strong> (ACN 098 630
                                  972, AFS Licence No. 330742) (referred to
                                  below as Caprock Limited, we, us, our)
                                  maintains a policy of strict confidence
                                  concerning any Personal Information you
                                  provide to us (Privacy Policy). The meaning of
                                  Personal Information is discussed in section 1
                                  below. This Privacy Policy has been developed
                                  in accordance with the{" "}
                                  <strong>Privacy Act 1988 (Cth)</strong> and
                                  the National Privacy Principles (Privacy Act).
                                  Our Privacy Policy applies to the collection,
                                  storage, use, and disclosure of your Personal
                                  Information.
                                </p>

                                <p className="mb-2">
                                  <strong>
                                    1. What Personal Information do we collect?
                                  </strong>
                                </p>
                                <p className="mb-2">
                                  "Personal Information" means information or an
                                  opinion about an individual whose identity is
                                  apparent, or can reasonably be ascertained,
                                  from the information or opinion. We may obtain
                                  Personal Information to provide you with our
                                  services and products or to manage our
                                  relationship with you. The types of Personal
                                  Information we may collect include:
                                </p>
                                <ul className="list-disc pl-6 mb-2">
                                  <li>Your full name</li>
                                  <li>
                                    Contact details (residential address,
                                    telephone number, email address)
                                  </li>
                                  <li>Date of birth</li>
                                  <li>Tax file number</li>
                                  <li>Your financial details and interests</li>
                                  <li>
                                    Products and services we have provided to
                                    you
                                  </li>
                                </ul>

                                <p className="mb-2">
                                  We collect Personal Information when you:
                                </p>
                                <ul className="list-disc pl-6 mb-4">
                                  <li>
                                    Visit the Website to read or download
                                    information
                                  </li>
                                  <li>
                                    Contact one of our directors or employees by
                                    telephone or email
                                  </li>
                                  <li>
                                    Make an enquiry about our products or
                                    services
                                  </li>
                                  <li>Become one of our clients</li>
                                </ul>

                                <p className="mb-2">
                                  Sometimes, we may need to collect Personal
                                  Information about individuals who are not our
                                  customers (e.g., business contact details of a
                                  company representative with whom we deal or
                                  your representative or agent, such as your
                                  accountant).
                                </p>
                                <p className="mb-2">
                                  Generally, we will not collect sensitive
                                  information about you (such as your race,
                                  political or religious beliefs or your health)
                                  unless for some reason we need to do so in
                                  order to provide you with our products or
                                  services. If we do need sensitive information,
                                  we will seek your consent when we collect the
                                  information (unless an exemption applies).{" "}
                                </p>
                                <p className="mb-2">
                                  <strong>
                                    2. How is Personal Information collected and
                                    stored?
                                  </strong>
                                </p>
                                <p className="mb-1">
                                  This depends on how you deal with us and the
                                  products and services you might request from
                                  us.{" "}
                                </p>
                                <p className="mb-1">
                                  We may collect Personal Information about you
                                  from an application form or verbally if you
                                  call us or speak directly with our staff. In
                                  addition, if you access our website, this will
                                  mean that we will collect Personal Information
                                  electronically.
                                </p>
                                <p className="mb-1">
                                  Some of our pages on the Website use
                                  "cookies", which are small files that may be
                                  placed on your hard disk for record-keeping
                                  purposes. Cookies helps us remember who you
                                  are and may collect and store your server
                                  address, the date and time of your visit, the
                                  pages viewed and any downloads made. Cookies
                                  can make your subsequent visits to the Website
                                  simpler and more efficient. We may also use
                                  the information to assist in improving the
                                  Website, marketing and product development.{" "}
                                </p>
                                <p className="mb-1">
                                  You can set your browser to notify you when
                                  you receive a cookie, giving you the chance to
                                  decide whether or not to accept it. (However,
                                  by not accepting cookies, some pages on the
                                  Website may not display properly or you may
                                  not be permitted to access certain
                                  information.) A server cannot find out a name
                                  or email address, or anything about you by
                                  using cookies. Cookie information is not
                                  stored or collected by us. Once we receive
                                  information from you, via email or any other
                                  means, the information is stored in a secure
                                  environment. Caprock Limited takes reasonable
                                  steps to protect the Personal Information it
                                  holds from loss and unauthorised access,
                                  destruction, use, modification or disclosure.
                                </p>

                                <p className="mb-2">
                                  <strong>
                                    3. How do we use Personal Information
                                    collected by us?
                                  </strong>
                                </p>
                                <ul className="list-disc pl-6 mb-2">
                                  <li>
                                    Providing you with the relevant products or
                                    services requested
                                  </li>
                                  <li>Managing our relationship with you</li>
                                  <li>
                                    Managing and administering your investments
                                  </li>
                                  <li>Communicating about your investments</li>
                                  <li>
                                    if you have requested it, sending you
                                    information about us and our products and
                                    services
                                  </li>
                                  <li>Developing our products and services</li>
                                  <li>Marketing and research</li>
                                  <li>Statistical purposes</li>
                                  <li>Improving the content of the Website</li>
                                  <li>General internal purposes</li>
                                  <li>
                                    To help us manage, develop and enhance our
                                    services, including our applications and
                                    general product development
                                  </li>
                                </ul>
                                <p className="mb-1">
                                  If you would like to stop receiving
                                  communications from us, please contact our
                                  Privacy Officer (details below). If it is no
                                  longer necessary for us to have your Personal
                                  Information, we will take reasonable steps to
                                  destroy it in a secure manner or remove
                                  identifying features from it. This is subject
                                  to any legal obligation we have to keep
                                  Personal Information for a specific period of
                                  time.
                                </p>
                                <p className="mb-2">
                                  <strong>
                                    4. Will Personal Information be disclosed?
                                  </strong>
                                </p>
                                <p className="mb-2">
                                  Personal Information collected from you will
                                  only be used to send commercial electronic
                                  messages if express or inferred consent has
                                  been obtained. Our Privacy Policy is designed
                                  to maintain the confidentiality of all
                                  Personal Information held by us and prevent
                                  its misuse. Our Privacy Policy is designed to
                                  maintain the confidentiality of all Personal
                                  Information held by us and prevent its misuse.
                                </p>
                                <p className="mb-2">
                                  In some circumstances, however, Personal
                                  Information may be disclosed outside Caprock
                                  Limited. For example:
                                </p>
                                <ul className="list-disc pl-6 mb-2">
                                  <li>
                                    For legal reasons, disclosures may need to
                                    be made to law enforcement agencies,
                                    government agencies, courts or external
                                    advisors
                                  </li>
                                  <li>
                                    In some circumstances, Personal Information
                                    is disclosed to third parties where this is
                                    related to the supply of our products or
                                    services. If we make disclosures of this
                                    kind, you will be advised of these
                                    disclosures at the time you request us to
                                    supply you with our products or services.{" "}
                                  </li>
                                  <li>
                                    Some of these organisations are located
                                    overseas in Sri Lanka.
                                  </li>
                                </ul>
                                <p className="mb-2">
                                  Personal Information may be disclosed to third
                                  parties to whom we contract out specialised
                                  functions, such as software suppliers, mailing
                                  houses and printing companies. If so, we take
                                  steps to ensure that those contractors comply
                                  with the Privacy Act, and are authorised only
                                  to use Personal Information in order to
                                  perform the functions required by us.
                                </p>
                                <p className="mb-2">
                                  <strong>
                                    5. How do I access and correct my Personal
                                    Information?
                                  </strong>
                                </p>
                                <p className="mb-2">
                                  Under the Privacy Act, you have a right to
                                  seek access to information which we hold about
                                  you. However, there are some exceptions to
                                  this. You also have the right to ask us to
                                  correct information about you which is
                                  inaccurate, incomplete or out of date. Our
                                  policy is to consider any requests for access
                                  or correction in an appropriate and timely
                                  fashion. In order to provide you with access
                                  to your Personal Information, we ordinarily
                                  would provide you with a hard copy print-out
                                  of the relevant Personal Information from our
                                  current databases, or with photocopies of
                                  records which are held only on current paper
                                  files. If you have any questions about this
                                  Privacy Policy, if you wish to complain about
                                  how we have handled Personal Information about
                                  you, or if you wish to access or correct your
                                  Personal Information, please contact our
                                  Privacy Officer. See paragraph 10 below for
                                  the Privacy Officer's contact details.
                                </p>

                                <p className="mb-2">
                                  <strong>
                                    6. What about Security and Transborder Data
                                    Flow?
                                  </strong>
                                </p>
                                <p className="mb-2">
                                  As mentioned we will use reasonable steps to
                                  maintain a secure system for storing Personal
                                  Information. Technological and operational
                                  policies and procedures are in place to
                                  protect Personal Information from misuse and
                                  loss and from unauthorised modification or
                                  disclosure. However, while we strive to
                                  protect your Personal Information, we cannot
                                  ensure or warrant the security of any
                                  information transmitted to us (e.g. by email)
                                  and you do so at your own risk. Personal
                                  Information will not be transferred overseas
                                  unless there is a reasonable belief that it
                                  will be collected, used or disclosed by the
                                  recipients in accordance with this Privacy
                                  Policy.
                                </p>

                                <p className="mb-2">
                                  <strong>
                                    7. Do you use Government Identifiers?
                                  </strong>
                                </p>
                                <p className="mb-2">
                                  We do not use tax file numbers, Medicare
                                  numbers or any other Government identifier for
                                  the purposes of identifying clients with
                                  products or services. The only circumstances
                                  in which we may collect such information is
                                  where we are required by law to do so.
                                </p>

                                <p className="mb-2">
                                  <strong>
                                    8.What about the Anti-Money Laundering and
                                    Counter-Terrorism Financing Act 2006?
                                  </strong>
                                </p>
                                <p className="mb-2">
                                  In order to comply with this legislation, in
                                  most cases, we must now obtain, verify and
                                  record Personal Information that verifies
                                  clients who wish to invest using our services.
                                  The Personal Information collected for this
                                  specific purpose includes your full name, date
                                  of birth and residential address. We are
                                  obliged by law to store this information for a
                                  minimum of seven years. The Personal
                                  Information collected for the purposes of this
                                  legislation will not be disclosed to any third
                                  party unless:
                                </p>
                                <ul className="list-disc pl-6 mb-2">
                                  <li>
                                    we have obtained your consent and informed
                                    you of the recipients of your Personal
                                    Information
                                  </li>
                                  <li>
                                    If we are obliged to disclose your Personal
                                    Information by law.
                                  </li>
                                </ul>
                                <p className="mb-2">
                                  <strong>
                                    9.What about links and references to Third
                                    Party Websites?
                                  </strong>
                                </p>
                                <p className="mb-2">
                                  The Website may contain links and references
                                  to third party websites. We encourage you to
                                  read the privacy policies on these third party
                                  websites as they may differ from ours.
                                </p>

                                <p className="mb-2">
                                  <strong>
                                    10. How do I contact your Privacy Officer?
                                  </strong>
                                </p>
                                <p className="mb-2">
                                  Please contact our PRIVACY OFFICER if you: *
                                  have any questions about this Privacy Policy;{" "}
                                </p>
                                <ul className="list-disc pl-6 mb-2">
                                  <li>
                                    Would like us to stop sending you
                                    COMMUNICATIONS.
                                  </li>
                                  <li>
                                    Wish to make a complaint about how we have
                                    handled your Personal information
                                  </li>
                                  <li>
                                    Would like to access or correct your
                                    Personal Information held by us.
                                  </li>
                                </ul>
                                <p className="mb-4">
                                  <strong>GROUP LEGAL AND COMPLIANCE</strong>
                                  <br />
                                  Email:{" "}
                                  <a
                                    href="mailto:legal@caprock.com.au"
                                    className="text-[#003478]"
                                  >
                                    legal@caprock.com.au
                                  </a>
                                  <br />
                                  Caprock Pty Limited,
                                  <br />
                                  LEVEL 2, 222 PITT STREET,
                                  <br />
                                  Sydney NSW 2000, Australia
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSignup;
